export default __webpack_public_path__ + "static/media/callaboration-1.065ee5dc.png";